var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sorting-select"},[_c('vb-dropdown',{attrs:{"vb_options":{
      text: _vm.current_label,
      size: 'sm',
      right: true,
    }}},_vm._l((_vm.options),function(option,index){return _c('b-dropdown-item',{key:`sort-${index}`,attrs:{"active":option.value === _vm.sort},on:{"click":function($event){return _vm.$emit('order', option.value)}}},[_vm._v(" "+_vm._s(option.text)+" ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }